/**
 * Created by Jerker Nord on 2023-06-10.
 */
import {StageLayer} from "@nolimitcity/slot-launcher/bin/StageLayer";
import {LonerGameAssets} from "../../LonerGameAssets";
import {Loner} from "../../Loner";
import {gsap} from "gsap";
import {MathHelper} from "@nolimitcity/slot-game/bin/utils/MathHelper";
import {SpineUtils} from "../../utils/SpineUtils";

export class LonerTVMessageView extends PIXI.Container implements StageLayer {

    private static MAIN_CONTAINER_POSITION:PIXI.Point = new PIXI.Point(0, 515);
    private static MESSAGE_SPEED:number = 8;
    private static BROKEN_ANIMATION_POSITION:PIXI.Point = new PIXI.Point(350, 30);

    private _mainContainer:PIXI.Container;
    private _messageContainer:PIXI.Container;
    private _messageContainers:PIXI.Container[];
    private _messageTLs:gsap.core.Timeline[];
    private _brokenAnimation:PIXI.spine.Spine;
    private _flickerTL:gsap.core.Timeline;
    private _isRunning:boolean;
    private _spinCounter:number;
    private _triggerValue:number;
    private _previousMessageIndex:number;
    private _bottomReelMask:PIXI.Sprite;

    constructor() {
        super();
        this.name = "LonerTVMessageView";
        this.init();
    }

    private init():void {
        this._isRunning = false;
        this._triggerValue = MathHelper.randomIntInRange(3, 6);
        this._spinCounter = this._triggerValue;
        this._previousMessageIndex = -1;

        this._bottomReelMask = new PIXI.Sprite(Loner.assetLoader.getTextures(LonerGameAssets.TV_MESSAGE_REEL_MASK)[0]);
        this._bottomReelMask.anchor.set(0.5, 0.5);
        this._bottomReelMask.position.set(360, 540);
        this._bottomReelMask.alpha = 0.8;
        this.addChild(this._bottomReelMask);

        this._mainContainer = new PIXI.Container();
        this._mainContainer.position = LonerTVMessageView.MAIN_CONTAINER_POSITION;
        this.addChild(this._mainContainer);

        this._brokenAnimation = new PIXI.spine.Spine(Loner.assetLoader.getSpineAsset(LonerGameAssets.TV_MESSAGE_SPINE));
        this._brokenAnimation.position = LonerTVMessageView.BROKEN_ANIMATION_POSITION;
        this._mainContainer.addChild(this._brokenAnimation);

        this._messageContainer = new PIXI.Container();
        this._mainContainer.addChild(this._messageContainer);

        this._messageContainers = [];
        this._messageTLs = [];
        for(let i:number = 0; i < LonerGameAssets.TV_MESSAGES.length; i++) {
            let messageSprite:PIXI.Sprite = new PIXI.Sprite(Loner.assetLoader.getTextures(LonerGameAssets.TV_MESSAGES[i])[0]);
            let messageContainer:PIXI.Container = new PIXI.Container();
            messageContainer.visible = false;
            messageContainer.addChild(messageSprite);
            this._messageContainers.push(messageContainer);
            this._messageContainer.addChild(messageContainer);

            const messageTL:gsap.core.Timeline = gsap.timeline({
                paused : true,
                onComplete : () => this.messageComplete()
            });
            messageTL.add(() => {
                messageContainer.position.x = messageContainer.width;
                messageContainer.visible = true;
                this.isRunning = true;
                this.startFlicker();
            })
            messageTL.add(gsap.to(messageContainer.position, {
                duration : LonerTVMessageView.MESSAGE_SPEED,
                x : 0 - messageContainer.width,
                ease : "none"
            }));
            this._messageTLs.push(messageTL);
        }

        SpineUtils.resetSpineAnimation(this._brokenAnimation);
        this._brokenAnimation.state.setAnimation(0, "animation", true);

        this._flickerTL = gsap.timeline({repeat : -1, paused : true});
        this._flickerTL.add(gsap.timeline({delay : MathHelper.randomNumberInRange(0.04, 0.01, 2)}));
        this._flickerTL.add(() => {
            this._messageContainer.alpha = MathHelper.randomNumberInRange(0.5, 0.7, 2);
        });
        this._flickerTL.add(gsap.timeline({delay : MathHelper.randomNumberInRange(0.04, 0.01, 2)}));
        this._flickerTL.add(() => {
            this._messageContainer.alpha = MathHelper.randomNumberInRange(0.5, 0.7, 2);
        });
        this._flickerTL.add(gsap.timeline({delay : MathHelper.randomNumberInRange(0.04, 0.01, 2)}));
        this._flickerTL.add(() => {
            this._messageContainer.alpha = MathHelper.randomNumberInRange(0.5, 0.7, 2);
        });
        this._flickerTL.add(gsap.timeline({delay : MathHelper.randomNumberInRange(0.04, 0.01, 2)}));
        this._flickerTL.add(() => {
            this._messageContainer.alpha = MathHelper.randomNumberInRange(0.5, 0.7, 2);
        });
        this._flickerTL.add(gsap.timeline({delay : MathHelper.randomNumberInRange(0.04, 0.01, 2)}));
        this._flickerTL.add(() => {
            this._messageContainer.alpha = MathHelper.randomNumberInRange(0.5, 0.7, 2);
        });
        this._flickerTL.add(gsap.timeline({delay : MathHelper.randomNumberInRange(0.04, 0.01, 2)}));
        this._flickerTL.add(() => {
            this._messageContainer.alpha = MathHelper.randomNumberInRange(0.5, 0.7, 2);
        });
    }

    private messageComplete():void {
        this.isRunning = false;
        this._flickerTL.pause();
    }

    private startFlicker():void {
        this._flickerTL.restart();
    }

    public checkStartTVMessage():void {
        if(this._isRunning == true) {
            return;
        }
        this._spinCounter++;
        if(this._spinCounter > this._triggerValue) {
            this._spinCounter = 0;
            this._triggerValue = MathHelper.randomIntInRange(3, 6);
            let newMessageIndex:number = MathHelper.randomIntInRange(0, this._messageTLs.length - 1);
            while(this._previousMessageIndex == newMessageIndex) {
                newMessageIndex = MathHelper.randomIntInRange(0, this._messageTLs.length - 1);
            }
            this._messageTLs[newMessageIndex].restart();
            this._previousMessageIndex = newMessageIndex;
        }
    }

    get isRunning():boolean {
        return this._isRunning;
    }

    set isRunning(value:boolean) {
        this._isRunning = value;
    }

    public hide():void {
        this.visible = false;
    }

    public show():void {
        this.visible = true;
    }
}